export function extractNodesFromDocument(parsed) {
  if (Array.isArray(parsed)) {
    return parsed;
  }
  if (parsed && typeof parsed === "object" && Array.isArray(parsed.nodes)) {
    return parsed.nodes;
  }
  return [];
}

export function buildNodeLookup(nodes) {
  const byId = new Map();
  if (!Array.isArray(nodes)) {
    return byId;
  }
  nodes.forEach((node) => {
    if (!node || typeof node !== "object") {
      return;
    }
    const id = node.node_id ?? node.nodeId;
    if (id != null && String(id).trim() !== "") {
      byId.set(String(id), node);
    }
  });
  return byId;
}

export function resolveNodeDisplayName(node, nodeId) {
  if (node && typeof node === "object") {
    const name = node.node_name ?? node.nodeName;
    if (name != null && String(name).trim() !== "") {
      return String(name);
    }
  }
  return nodeId != null ? String(nodeId) : "Unknown node";
}
